import { useCurrentLocale as useI18nRouterCurrentLocale } from 'next-i18n-router/client';

import { i18nConfig } from '../constants';

export const useCurrentLocale = (fallbackLocale: string = i18nConfig.defaultLocale) => {
  const currentLocale = useI18nRouterCurrentLocale(i18nConfig);
  return currentLocale || fallbackLocale;
};
